import { useAnimatedNavigate } from "./useAnimatedNavigate";

export const useOpenPage = () => {
    const navigate = useAnimatedNavigate();
    return (url) => () => navigate(url);
}